import React, {useEffect, useState , useRef} from 'react'
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../../config.js";
import Assignee from "./Assignee";
import Actions from "./Actions";
import Costs from "./Costs";
import StatusHistory from './StatusHistory'
import Attachment from './Attachments'
import Reopen from './Reopen'
import Finish from './Finish'
import {trans} from "../../utils";
import {toast, ToastContainer} from "react-toastify";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";


const Index = (ComponentToRenderData) => {
    let history = useHistory();
    const params = useParams();
    const SystemUrl = ComponentToRenderData.SystemUrl;
    const token = localStorage.getItem('token')
    const [data, setData ] = useState([]);
    const [data2, setData2 ] = useState([]);
    const [dataDocument, setDataDocument ] = useState([]);
    const [dataDocumentType, setDataDocumentType ] = useState([]);
    const [data5, setData5 ] = useState([]);
    const [AttachmentShow, setAttachmentShow ] = useState(false);
    const [ReopenShow, setReopenShow ] = useState(false);
    const [FinishShow, setFinishShow ] = useState(false);
    const [StatusHistoryShow, setStatusHistoryShow ] = useState(false);
    const [CostsShow, setCostsShow ] = useState(false);
    const [ActionsShow, setActionsShow ] = useState(false);
    const search = window.location.search;
    let URLParams = new URLSearchParams(search);
    const statusColor = {
        "Assigned" : "badge-info",
        "Created":"badge-primary",
        "Reopened":"badge-primary",
        "Active":"badge-light-info",
        "Finished":"badge-dark",
        "Closed":"badge-success",
        "Skipped":"badge-warning",
        "Signed Off":"badge-light-success",
        "Pending for Approval":"badge-light-dark",
        "Pending":"badge-light-dark"
    }
    useEffect(() => {
        axios(config.SystemUrl + `WorkOrder/${params.id}?include=requested_by_user,category,type,contract,priority,ticket,room_space_item,status_data,finish_data,room_space_item.assign_asset_item.asset_item,room_space_item.assign_asset_item.asset_item.ecri,room_space_item.facility,room_space_item.facility.customer,room_space_item.facility.sub_customer,room_space_item.building,room_space_item.floor,room_space_item.room,room_space_item.room.department`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => setData(result.data.data));

    }, [])

    useEffect(() => {
        axios(config.SystemUrl + `select/Admin?role_id=34`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => setData2(result.data.data) );
    }, [])

    useEffect(() => {
        axios(config.SystemUrl + `select/AssetItemDocumentationGroup`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => setDataDocument(result.data.data) );
    }, [])

    useEffect(() => {
        axios(config.SystemUrl + `select/AssetItemDocumentationGroupType`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => setDataDocumentType(result.data.data) );
    }, [])


    useEffect(() => {
        axios(config.SystemUrl + `select/WorkOrderFailureType`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => setData5(result.data.data) );
    }, [])





    const sendRequest = (data,url =null,callback = function(){ window.location.reload(); }) =>
    {
        url = url ? url : `WorkOrder/${params.id}`
        var formData = new FormData();
        for ( let key in data ) {
            formData.append(key, data[key]);
        }
        formData.append('work_order_id', params.id);
        axios.post(config.SystemUrl + url , formData,
            { headers:{
        'content-type': 'multipart/form-data'
        }})
            .then(response => {
                toast.success('Success');
                callback();
            }).catch(err => {

            // toast(error)
            toast.error(err.response.data.msg, { position: toast.POSITION.UPPER_RIGHT });
        });

    }

    const componentRef = useRef();

    return (
        <>
       <div className="row">

           <div className="col-md-4">
               <div className="card mb-5">
                   { data.status_data &&
                   <span className={"p-20 text-center " + statusColor[data.status_data.title_en]}>

                       <h4>{trans(data.status_data.title)}</h4>

                       <h6  ref={componentRef}>{trans('WO')} #{data.id}</h6>
                   </span>
                   }
                   {data.ticket &&
                       <span className="p-2 bg-light text-center">
                          <h4  ref={componentRef}>  {trans('Ticket')} #{data.ticket.id}</h4>
                        </span>
                    }
               </div>
            <div className="card mb-5">
               <div className="nav flex-column nav-pills menu-rounded menu-column menu-title-gray-700 menu-active-bg-light-primary fw-bold" id="v-pills-tab" role="tablist"
                    aria-orientation="vertical">
                   <div className="menu-item active" id="v-pills-asset-tab" data-toggle="pill" href="#v-pills-asset"
                        role="tab" aria-controls="v-pills-asset" aria-selected="false">
                       <a className={URLParams.get('track')==1 ? "nav-link": "nav-link menu-link py-3"} >
                           <h5>{trans('WO Information')} </h5>
                       </a>
                   </div>

                   <div className="separator"></div>
                   <div className="menu-item"  id="v-pills-actions-tab" data-toggle="pill" href="#v-pills-actions"
                        role="tab" aria-controls="v-pills-actions" aria-selected="false"
                        onClick={()=> {
                            if(!ActionsShow){
                                setActionsShow(true);
                            }
                        }}>
                       <a className="nav-link menu-link py-3">
                           <h5>{trans('Actions')}</h5>
                       </a>
                   </div>
                   <div className="separator"></div>
                   <div className="menu-item"  id="v-pills-costs-tab" data-toggle="pill" href="#v-pills-costs"
                        role="tab" aria-controls="v-pills-costs" aria-selected="false"
                        onClick={()=> {
                            if(!CostsShow){
                                setCostsShow(true);
                            }
                        }}>
                       <a className="nav-link menu-link py-3">
                           <h5>{trans('Costs')}</h5>
                       </a>
                   </div>

                   <div className="separator"></div>
                   <div className="menu-item"  id="v-pills-status-tab" data-toggle="pill" href="#v-pills-status"
                        role="tab" aria-controls="v-status-status" aria-selected="false"
                        onClick={()=> {
                            if(!StatusHistoryShow){
                                setStatusHistoryShow(true);
                            }
                        }}>
                       <a className="nav-link menu-link py-3">
                           <h5>{trans('Status History')}</h5>
                       </a>
                   </div>

                   <div className="separator"></div>
                   <div className="menu-item"  id="v-pills-attachments-tab" data-toggle="pill" href="#v-pills-attachments"
                        role="tab" aria-controls="v-status-attachments" aria-selected="false"
                        onClick={()=> {
                            if(!AttachmentShow){
                                setAttachmentShow(true);
                            }
                        }}>
                       <a className="nav-link menu-link py-3">
                           <h5>{trans('Attachments')}</h5>
                       </a>
                   </div>
                       <>
                           <div className="separator"></div>
                           <div className="menu-item"  id="v-pills-reopen-tab" data-toggle="pill" href="#v-pills-reopen"
                                role="tab" aria-controls="v-status-reopen" aria-selected="false"
                                onClick={()=> {
                                    if(!ReopenShow){
                                        setReopenShow(true);
                                    }
                                }}>
                               <a className="nav-link menu-link py-3">
                                   <h5>{trans('Reopened Comments')}</h5>
                               </a>
                           </div>
                       </>

                       <>
                           <div className="separator"></div>
                           <div className="menu-item"  id="v-pills-finish-tab" data-toggle="pill" href="#v-pills-finish"
                                role="tab" aria-controls="v-status-finish" aria-selected="false"
                                onClick={()=> {
                                    if(!FinishShow){
                                        setFinishShow(true);
                                    }
                                }}>
                               <a className="nav-link menu-link py-3">
                                   <h5>{trans('Finish Comments')}</h5>
                               </a>
                           </div>
                       </>


               </div>
           </div>
           </div>
           <div className="col-md-8">
               <div className="card">
                   <div className="tab-content" id="v-pills-tabContent">
                       <div className="tab-pane fade show active card"  id="v-pills-asset" role="tabpanel" aria-labelledby="v-pills-asset-tab">
                        <Assignee data={data} sendRequest={sendRequest} data2={data2} data5={data5}  params={params}/>
                       </div>
                       <div className="tab-pane fade card"  id="v-pills-actions" role="tabpanel" aria-labelledby="v-pills-actions-tab">
                           {ActionsShow && <Actions data={data} sendRequest={sendRequest}  params={params}/> }
                       </div>
                       <div className="tab-pane fade card"  id="v-pills-costs" role="tabpanel" aria-labelledby="v-pills-costs-tab">
                           {CostsShow && <Costs data={data} sendRequest={sendRequest} params={params}/>}
                       </div>
                       <div className="tab-pane fade card"  id="v-pills-status" role="tabpanel" aria-labelledby="v-pills-status-tab">
                           {StatusHistoryShow && <StatusHistory  params={params}/> }
                       </div>
                       <div className="tab-pane fade card"  id="v-pills-attachments" role="tabpanel" aria-labelledby="v-pills-status-tab">
                           {AttachmentShow && <Attachment sendRequest={sendRequest} dataDocumentType={dataDocumentType} dataDocument={dataDocument} params={params} data={data}/>}
                       </div>
                       <div className="tab-pane fade card"  id="v-pills-reopen" role="tabpanel" aria-labelledby="v-pills-status-tab">
                           {ReopenShow && <Reopen  params={params} data={data}/>}
                       </div>
                       <div className="tab-pane fade card"  id="v-pills-finish" role="tabpanel" aria-labelledby="v-pills-status-tab">
                           {FinishShow && <Finish  params={params} data={data}/>}
                       </div>
                   </div>
               </div>
           </div>
        </div>
            <ToastContainer />

        </>
    )
}
export default Index;
